export const MEETING_CO_PILOT_MODAL_LABEL = {
    id: 'oe.meeting.meetingCoPilot',
    description: 'Label text',
    defaultMessage: 'Meeting Co-Pilot'
};

export const CONTINUE_BUTTON_TEXT = {
    id: 'oe.meeting.meetingCoPilot',
    description: 'Button text',
    defaultMessage: 'Continue'
};

export const EDIT_DETAILS_MANUALLY = {
    id: 'oe.meeting.editDetailsManually',
    description: 'Label text',
    defaultMessage: 'Edit Details Manually'
};

export const LOADING_SPINNER_TEXT = {
    id: 'oe.meeting.generatingText',
    description: 'Spinner text',
    defaultMessage: 'Generating meeting(s) from text prompt...'
};

export const LOADING_SPINNER_TIME_TEXT = {
    id: 'oe.meeting.generatingTimeText',
    description: 'Spinner text',
    defaultMessage: 'This usually takes around 10 seconds.'
};

export const TEXT_AREA_LABEL = {
    id: 'oe.meeting.pasteTextHere',
    description: 'Label text',
    defaultMessage: 'Paste Text Here'
};

export const ORIGINAL_TEXT_LABEL = {
    id: 'oe.meeting.originalText',
    description: 'Label text',
    defaultMessage: 'Original Text',
};

export const CO_PILOT_MESSAGE_REQUIRED = {
    id: 'oe.meeting.fieldIsRequired',
    description: 'Warning message for required field',
    defaultMessage: '{field} is required',
};

export const CO_PILOT_MESSAGE_TOO_LONG = {
    id: 'oe.meeting.notesTooLong',
    description: 'Warning message for field too long',
    defaultMessage: 'Too long - max length is 4096 characters',
};

export const GENERATION_RESPONSE_TIMEOUT_ERR_MESSAGE = {
    id: 'oe.meeting.generatingResponseTimeoutErrMessage',
    description: 'Error message for generation response timeout',
    defaultMessage: 'Something went wrong while we were generating a response. Please try again.'
};